<template>
  <div class="EscuelasForm">
    <div class="md-layout md-gutter md-alignment-top-center">
      <div class="md-layout-item xsmall-size-100 md-size-100">
        <md-card class="mb24">
          <md-card-header>
            <div class="md-title">{{escuela.id_esc ? 'Editar' : 'Registrar'}} Escuela</div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-xsmall-size-100 md-size-33">
                <md-field :class="errores.nombre_esc">
                  <label>Nombre</label>
                  <md-input
                    :disabled="$session.get('tipo') != 'administrativo'"
                    v-model="escuela.nombre_esc"
                    required
                  />
                  <span class="md-error">{{$obligatorio}}</span>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-100 md-size-33">
                <md-field :class="errores.clave_esc">
                  <label>Clave</label>
                  <md-input
                    :disabled="$session.get('tipo') != 'administrativo'"
                    v-model="escuela.clave_esc"
                    required
                  />
                  <span class="md-error">{{$obligatorio}}</span>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-100 md-size-33">
                <md-field :class="errores.alias_esc">
                  <label>Alias</label>
                  <md-input
                    :disabled="$session.get('tipo') != 'administrativo'"
                    v-model="escuela.alias_esc"
                    required
                  />
                  <span class="md-error">{{$obligatorio}}</span>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-100 md-size-33">
                <md-field :class="errores.id_ces_esc">
                  <label>Jurisdicción</label>
                  <md-select
                    :disabled="$session.get('tipo') != 'administrativo'"
                    v-model="escuela.id_ces_esc"
                    md-dense
                    required
                  >
                    <md-option
                      v-for="item in categorias_escuelas"
                      :key="item.id_ces"
                      :value="item.id_ces.toString()"
                    >
                      {{item.nombre_ces}}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-100 md-size-33">
                <md-field :class="errores.id_edo_esc">
                  <label for="">Estados</label>
                  <md-select
                    :disabled="$session.get('tipo') != 'administrativo'"
                    md-dense
                    v-model="escuela.id_edo_esc"
                    @md-selected="_filterMpios"
                  >
                    <md-option
                      v-for="item in this.$estados"
                      :key="item.id_edo"
                      :value="item.id_edo"
                    >
                      {{item.nombre_edo}}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-100 md-size-33">
                <md-field :class="errores.id_mpio_esc">
                  <label for="">Municipio</label>
                  <md-select
                    :disabled="$session.get('tipo') != 'administrativo'"
                    v-model="escuela.id_mpio_esc"
                    md-dense
                  >
                    <md-option
                      v-for="item in municipios"
                      :key="item.id_mpio"
                      :value="item.id_mpio"
                    >
                      {{item.nombre_mpio}}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-100 md-size-33">
                <md-field :class="errores.calle_esc">
                  <label>Calle</label>
                  <md-input
                    v-model="escuela.calle_esc"
                    required
                  />
                  <span class="md-error">{{$obligatorio}}</span>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-100 md-size-33">
                <md-field :class="errores.num_ext_esc">
                  <label>No. Exterior</label>
                  <md-input
                    v-model="escuela.num_ext_esc"
                    required
                  />
                  <span class="md-error">{{$obligatorio}}</span>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-100 md-size-33">
                <md-field :class="errores.colonia_esc">
                  <label>Colonia</label>
                  <md-input
                    v-model="escuela.colonia_esc"
                    required
                  />
                  <span class="md-error">{{$obligatorio}}</span>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-100 md-size-33">
                <md-field :class="errores.cp_esc">
                  <label>C.P.</label>
                  <md-input
                    v-model="escuela.cp_esc"
                    required
                  />
                  <span class="md-error">{{$obligatorio}}</span>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-100 md-size-33">
                <md-field :class="errores.tipo_esc">
                  <label>Tipo</label>
                  <md-select
                    v-model="escuela.tipo_esc"
                    md-dense
                  >
                    <md-option value="publica">Publica</md-option>
                    <md-option value="privada">Privada</md-option>
                  </md-select>
                  <span class="md-error">{{$obligatorio}}</span>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-100 md-size-33">
                <md-field :class="errores.nivel_esc">
                  <label>Nivel</label>
                  <md-select
                    v-model="escuela.nivel_esc"
                    md-dense
                  >
                    <md-option value="guarderia">Guardería</md-option>
                    <md-option value="preescolar">Pre-Escolar</md-option>
                    <md-option value="primaria">Primaria</md-option>
                    <md-option value="otra">Otra</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-100 md-size-33">
                <md-field :class="errores.status">
                  <label>Estatus</label>
                  <md-select
                    v-model="escuela.status"
                    md-dense
                  >
                    <md-option value="activo">Activo</md-option>
                    <md-option value="inactivo">Inactivo</md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
          </md-card-content>
          <md-card-actions>
            <md-button to="/escuelas">Regresar</md-button>
            <md-button
              v-if="$session.get('tipo') != 'otro'"
              class="md-primary md-raised"
              @click="_presave()"
            >{{escuela.id_esc ? 'Actualizar' : 'Guardar'}}</md-button>
          </md-card-actions>
        </md-card>
        <Loading v-if="cargando" />
      </div>
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-size-33 mb24"
        v-if="$route.params.idEscuela"
      >
        <EscuelasDetalleContactos
          :escuela.sync="escuela"
          :contactos="escuelas_contactos"
          @msg="_notify"
        />
      </div>
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-size-33 mb24"
        v-if="$route.params.idEscuela"
      >
        <CitasComponente
          :escuela.sync="escuela"
          :escuelas_citas="escuelas_citas"
          @msg="_notify"
        />
      </div>
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-size-33 mb24"
        v-if="$route.params.idEscuela && isOnline"
      >
        <EscuelaFotos
          :escuela.sync="escuela"
          :escuelas_citas="escuelas_citas"
          @msg="_notify"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "name",
  components: {
    Loading: () => import("@/components/Loading.vue"),
    EscuelasDetalleContactos: () =>
      import("@/components/escuelas/EscuelasDetalleContactos.vue"),
    CitasComponente: () => import("@/components/citas/CitasComponente.vue"),
    EscuelaFotos: () => import("@/components/escuelas/EscuelaFotos.vue")
  },
  methods: {
    _notify(a) {
      this.$emit("msg", a);
    },
    _filterMpios(a) {
      this.municipios = this.$municipios["a" + a];
    },
    _falloResponse(err) {
      this.cargando = false;
      if (err.status === 401) {
        this.$router.push("/login");
      } else {
        this.$emit("msg", this.$no_internet);
      }
    },
    _obtenerEscuela() {
      let idEscuela = this.$route.params.idEscuela;
      if (this.$session.get("tipo") === "medico") {
        let index = this.escuelas.findIndex(function(b) {
          return b.id === idEscuela;
        });
        if (index >= 0) {
          this.indexEscuela = index;
          this.escuela.id = this.escuelas[index].id;
          this.escuela.id_esc = this.escuelas[index].id_esc;
          this.escuela.nombre_esc = this.escuelas[index].nombre_esc;
          this.escuela.clave_esc = this.escuelas[index].clave_esc;
          this.escuela.alias_esc = this.escuelas[index].alias_esc;
          this.escuela.id_edo_esc = this.escuelas[index].id_edo_esc;
          this.escuela.id_mpio_esc = this.escuelas[index].id_mpio_esc;
          this.escuela.calle_esc = this.escuelas[index].calle_esc;
          this.escuela.num_ext_esc = this.escuelas[index].num_ext_esc;
          this.escuela.colonia_esc = this.escuelas[index].colonia_esc;
          this.escuela.cp_esc = this.escuelas[index].cp_esc;
          this.escuela.lat_esc = this.escuelas[index].lat_esc;
          this.escuela.lng_esc = this.escuelas[index].lng_esc;
          this.escuela.tipo_esc = this.escuelas[index].tipo_esc;
          this.escuela.nivel_esc = this.escuelas[index].nivel_esc;
          this.escuela.status = this.escuelas[index].status;
          this.escuela.id_ces_esc = this.escuelas[index].id_ces_esc;
        } else {
          this.$emit("msg", "Escuela no encontrada. Inténtelo de nuevo.");
          this.$router.push("/");
        }
      } else {
        this.$http
          .get(
            "escuelas/" + this.$enc(this.$route.params.idEscuela),
            this.$headers
          )
          .then(
            res => {
              this.cargando = false;
              if (res.status === 401) {
                this.$router.push("/login");
              } else if (res.status === 200 && "escuela" in res.body) {
                this.escuela = res.body.escuela;
                this.escuelas_contactos = res.body.escuelas_contactos;
                this.escuelas_citas = res.body.escuelas_citas;
              } else {
                this.$emit("msg", res.body.error);
              }
            },
            err => {
              this._falloResponse(err);
            }
          );
      }
    },
    _validar() {
      this.errores.nombre_esc = this.$mdError(this.escuela.nombre_esc);
      this.errores.clave_esc = this.$mdError(this.escuela.clave_esc);
      this.errores.alias_esc = this.$mdError(this.escuela.alias_esc);
      this.errores.calle_esc = this.$mdError(this.escuela.calle_esc);
      this.errores.num_ext_esc = this.$mdError(this.escuela.num_ext_esc);
      this.errores.colonia_esc = this.$mdError(this.escuela.colonia_esc);
      this.errores.cp_esc = this.$mdError(this.escuela.cp_esc);
      this.errores.id_edo_esc = this.$mdError(this.escuela.id_edo_esc);
      this.errores.id_mpio_esc = this.$mdError(this.escuela.id_mpio_esc);
      this.errores.tipo_esc = this.$mdError(this.escuela.tipo_esc);
      this.errores.nivel_esc = this.$mdError(this.escuela.nivel_esc);
      this.errores.id_ces_esc = this.$mdError(this.escuela.id_ces_esc);
      return this.$validate(this.errores);
    },
    _presave() {
      if (this._validar()) {
        this.escuela.id ? this._actualizar() : this._guardar();
      } else {
        this.$emit("msg", this.$llene_campos);
      }
    },
    _guardar() {
      if (this.isOnline) {
        this.$http
          .post("escuelas", { escuela: this.escuela }, this.$headers)
          .then(
            res => {
              this.cargando = false;
              if (res.status === 401) {
                this.$router.push("/login");
              } else if (res.status === 201) {
                this.$emit("msg", "Escuela creada");
                this.$router.push("/escuela/" + res.body.id_esc);
              } else {
                this.$emit("msg", res.body.error);
              }
            },
            err => this._falloResponse(err)
          );
        this.$emit("msg", "Escuela guardada");
      } else {
        this.$emit(
          "msg",
          "Necesitas estar conectado a internet para poder guardar la escuela"
        );
      }
    },
    _actualizar() {
      if (this.isOnline) {
        this.cargando = true;
        this.$http
          .put(
            "escuela/" + this.escuela.id,
            { escuela: this.escuela },
            this.$headers
          )
          .then(
            res => {
              this.cargando = false;
              if (res.status === 401) {
                this.$router.push("/login");
              } else if (res.status === 200) {
                this.$emit("msg", "Escuela actualizada");
                this.$router.push("/escuelas");
              } else {
                this.$emit("msg", res.body.error);
              }
            },
            err => this._falloResponse(err)
          );
      }
      if (this.$session.get("tipo") === "medico") {
        this.cargando = true;
        if (!this.isOnline) {
          this.escuelas[this.indexEscuela].id = "u." + this.escuela.id;
        }
        this.escuelas[this.indexEscuela].id_ces_esc = this.escuela.id_ces_esc;
        this.escuelas[this.indexEscuela].nombre_esc = this.escuela.nombre_esc;
        this.escuelas[this.indexEscuela].clave_esc = this.escuela.clave_esc;
        this.escuelas[this.indexEscuela].alias_esc = this.escuela.alias_esc;
        this.escuelas[this.indexEscuela].id_edo_esc = this.escuela.id_edo_esc;
        this.escuelas[this.indexEscuela].id_mpio_esc = this.escuela.id_mpio_esc;
        this.escuelas[this.indexEscuela].calle_esc = this.escuela.calle_esc;
        this.escuelas[this.indexEscuela].num_ext_esc = this.escuela.num_ext_esc;
        this.escuelas[this.indexEscuela].colonia_esc = this.escuela.colonia_esc;
        this.escuelas[this.indexEscuela].cp_esc = this.escuela.cp_esc;
        this.escuelas[this.indexEscuela].lat_esc = this.escuela.lat_esc;
        this.escuelas[this.indexEscuela].lng_esc = this.escuela.lng_esc;
        this.escuelas[this.indexEscuela].tipo_esc = this.escuela.tipo_esc;
        this.escuelas[this.indexEscuela].nivel_esc = this.escuela.nivel_esc;
        this.escuelas[this.indexEscuela].status = this.escuela.status;
      }
      this.cargando = false;
      this.$emit("msg", "Escuela actualizada");
    },
    _checkRoute() {
      if (this.$route.params.idEscuela) {
        this._obtenerEscuela();
      } else {
        this._limpiarCampos();
      }
    },
    _limpiarCampos() {
      this.escuela.id = null;
      this.errores.id = null;
      this.escuela.id_esc = null;
      this.errores.id_esc = null;
      this.escuela.nombre_esc = null;
      this.errores.nombre_esc = null;
      this.escuela.clave_esc = null;
      this.errores.clave_esc = null;
      this.escuela.alias_esc = null;
      this.errores.alias_esc = null;
      this.escuela.id_edo_esc = null;
      this.errores.id_edo_esc = null;
      this.escuela.id_mpio_esc = null;
      this.errores.id_mpio_esc = null;
      this.escuela.calle_esc = null;
      this.errores.calle_esc = null;
      this.escuela.num_ext_esc = null;
      this.errores.num_ext_esc = null;
      this.escuela.colonia_esc = null;
      this.errores.colonia_esc = null;
      this.escuela.cp_esc = null;
      this.errores.cp_esc = null;
      this.escuela.lat_esc = null;
      this.errores.lat_esc = null;
      this.escuela.lng_esc = null;
      this.errores.lng_esc = null;
      this.escuela.tipo_esc = null;
      this.errores.tipo_esc = null;
      this.escuela.nivel_esc = null;
      this.errores.nivel_esc = null;
      this.escuela.status = null;
      this.errores.status = null;
      this.escuela.id_ces_esc = null;
      this.errores.id_ces_esc = null;
    },
    _getCategorias() {
      this.$http.get("categorias", this.$headers).then(
        res => {
          this.cargando = false;
          if (res.status === 401) {
            this.$router.push("/login");
          } else if (res.status === 200 && "categorias" in res.body) {
            this.categorias_escuelas = res.body.categorias;
          } else {
            this.$emit(
              "msg",
              "Es necesario cuentes con una conexión a internet para poder registrar o editar una escuela"
            );
            this.$router.push("/");
          }
        },
        err => this._falloResponse(err)
      );
    }
  },
  data() {
    return {
      cargando: false,
      categorias_escuelas: [],
      escuelas_contactos: [],
      escuelas_citas: [],
      escuelas: [],
      escuela: {
        id_esc: null,
        nombre_esc: null,
        clave_esc: null,
        alias_esc: null,
        id_edo_esc: null,
        id_mpio_esc: null,
        calle_esc: null,
        num_ext_esc: null,
        colonia_esc: null,
        cp_esc: null,
        lat_esc: null,
        lng_esc: null,
        tipo_esc: null,
        nivel_esc: null,
        status: "activo",
        id_ces_esc: null
      },
      errores: {
        nombre_esc: null,
        clave_esc: null,
        alias_esc: null,
        calle_esc: null,
        num_ext_esc: null,
        colonia_esc: null,
        cp_esc: null,
        lat_esc: null,
        lng_esc: null,
        id_edo_esc: null,
        id_mpio_esc: null,
        tipo_esc: null,
        nivel_esc: null,
        id_ces_esc: null
      },
      municipios: [],
      indexEscuela: null
    };
  },
  created() {
    this._getCategorias();
    if (this.$session.get("tipo") === "medico") {
      if (localStorage.getItem("escuelas")) {
        this.escuelas = JSON.parse(localStorage.getItem("escuelas"));
      } else {
        this.$emit("msg", this.$syncInfo);
        this.$router.push("/");
      }
    } else {
      if (this.$route.params.idEscuela) {
        this._obtenerEscuela();
      }
    }
    this._checkRoute();
  },
  beforeCreate() {
    if (!this.$session.exists() && !this.$session.get("tipo")) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  },
  watch: {
    $route(to, from) {
      this._checkRoute();
    },
    escuelas: {
      handler() {
        if (this.$session.get("tipo") === "medico") {
          localStorage.setItem("escuelas", JSON.stringify(this.escuelas));
        }
      },
      deep: true
    }
  }
};
</script>